import { useTranslations } from "next-intl";
import { PageConfigDT } from "@shared/components/page-config/types";

const landingPageStaticConfig: PageConfigDT = {
  jsonLd: [],
  enableYektanet: true,
  enableHotjar: false,
  enableNajvaPushNotification: true,
  meta: {
    title: "",
    description: "",
  },
};

const useLandingConfig = (title: string, description: string) => {
  const t = useTranslations("meta");

  const result: PageConfigDT = {
    ...landingPageStaticConfig,
    meta: {
      title: title || t("title"),
      description: description || t("desc"),
    },
  };
  return result;
};

export default useLandingConfig;
